export default {
  availableCredits: (state) => {
    const availableInitialCredits = state.initialCredits.reduce((acc, current) => {
      return acc + current.used;
    }, 0);
    const availableStandardCredits = state.standardCredits.reduce((acc, current) => {
      return acc + current.used + current.excessUsed;
    }, 0);
    const availableExtraCredits = state.extraCredits.reduce((acc, current) => {
      return acc + current.used;
    }, 0);
    return availableInitialCredits + availableStandardCredits + availableExtraCredits;
  }
};
